import { createRoot } from 'react-dom/client';
import './index.css';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App';
import { StrictMode } from 'react';
import * as Sentry from '@sentry/react';


Sentry.init({
  dsn: "https://2314d195e2e2bfe7306f81fe0f0f2c2e@o4508920210063360.ingest.de.sentry.io/4509032350679120",
  environment: import.meta.env.VITE_APP_ENV,
  release: import.meta.env.VITE_APP_SENTRY_RELEASE,
});

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <ChakraProvider
      toastOptions={{
        defaultOptions: {
          position: 'bottom',
          containerStyle: {
            m: '6px',
            ['.chakra-toast:last-of-type &' as string]: { mb: '36px' },
          },
        },
      }}
    >
      <App />
    </ChakraProvider>
  </StrictMode>
);
